<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/58am9E/tc-custom/9780830855230.jpg?1696024552232" alt="This image is the cover for the book The Beginning and End of All Things, Essential Studies in Biblical Theology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Beginning and End of All Things, Essential Studies in Biblical Theology
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Many Christians think of the doctrine of creation primarily as relating to the world's origins.</strong> In <em>The Beginning and End of All Things</em>, Edward W. Klink III presents a more holistic understanding of creation—a story that is unfolded throughout all of Scripture and is at the core of the gospel itself.</p> <p>From beginning to end, the theme of creation and new creation not only directs the movement of the entire biblical story but also unifies its message. Klink explores the goodness of the physical world and how it will be perfected in the new creation of heaven and earth. Along with offering rich insights about God and his purposes for the world, a biblical theology of creation guides how we engage nature, culture, and life as embodied beings.</p> <p>Essential Studies in Biblical Theology (ESBT), edited by Benjamin L. Gladd, explore the central or <em>essential</em> themes of the Bible's grand storyline. Taking cues from Genesis 1–3, authors trace the presence of these themes throughout the entire sweep of redemptive history. Written for students, church leaders, and laypeople, the ESBT offers an introduction to biblical theology.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward W. Klink III, Benjamin L. Gladd
      </h2>
      
      <p class="authorDescription body article"><p>Edward W. Klink III (PhD, St. Andrews) is senior pastor of Hope Evangelical Free Church in Roscoe, Illinois. His books include <em>Understanding Biblical Theology: A Comparison of Theory and Practice, John</em> in the Zondervan Exegetical Commentary on the New Testament series, and <em>The Local Church: What It Is and Why It Matters for Every Christian</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b326a622